import React, {Fragment, useEffect,  useState} from 'react';
import PropTypes from "prop-types";
// var bootbox = require('bootbox');

import {useForm} from "react-hook-form";
import ModalContentWrapper from '../ModalContentWrapper';
import {getDataFromResponse, getNamedCustomDataFromResponse} from "root/DataFunctions/BaseDataFns";
import SpinnerDiv from "root/Components/SpinnerDiv";
import {getUserDetails, saveNewUser, updateUserDetails, checkUserRefNumber } from "root/DataFunctions/UserDataFns";
import DemoModal from "root/DemoModal";
import {getChildImageUrl} from "root/DataFunctions/ChildDataFns";
import ErrorDiv from "root/ReactHookForm/ui/ErrorDiv";
import DropdownUserTypes from "root/ReactHookForm/ui/DropdownUserTypes";
import DropdownOrgTeams from "root/ReactHookForm/ui/DropdownOrgTeams";
import {UserRoleGroups, UserTypes} from "root/DataFunctions/Constants";
import FormToggle from "root/ReactHookForm/ControlWrappers/FomToggle";
import DropdownOrganisations from "root/ReactHookForm/ui/DropdownOrganisations";

import {useGlobalContext} from "root/contexts/GlobalContext";

const ModalAddUser = (props) =>
{
    const [buttonState, setButtonState] = useState ('') ;
    const [data, setData] = useState({ isLoading: props.post_id !== null, data: [] });
    const [newImageData, setNewImageData] = useState( null );
    const [imageDataAlias, setImageDataAlias] = useState( null );

    const { userType } = useGlobalContext() ;

    const defaultUserType = userType === UserTypes.FOREVER_PARENT ? { value: 11 } : null ;

    const {register, control, handleSubmit, setFocus, watch, setValue, formState: {errors: formErrors}} = useForm(
        {
            defaultValues: {
                user: {
                    user_id: { value : 0 } , /* This field uses raw dropdown-select objects */
                    firstname: '',
                    surname: '',
                    description: '',
                    username: '',
                    us_description: '',
                    userTypeId: defaultUserType,
                    team_id: '',
                    status: 0,
                    email: '',
                    telno: '',
                    address1: '',
                    address2: '',
                    address3: '',
                    postcode: '',
                    unique_user_reference: null,
                    email_notifications: 0,
                }
            }
        });

    const titles = {
        view: 'View User',
        edit: 'Edit User',
        create: 'New User',
        delete: 'Archive User'
    } ;

    const submitButtonText = () => {
        switch (props.mode){
            case 'view':
                return 'Close';
                break;

            case 'edit':
                return 'Save';
                break;

            case 'create':
                return 'Save';
                break;

            case 'delete':
                return 'Delete';
                break;
        }
    } ;

    useEffect(() =>
    {
        if ( props.user_id !== null )
        {
            getUser();
        }
        else
        {
            if ( props.mode === 'create')
            {
                setData({ isLoading: false});
            }
        }

    }, []);

    //Get the user details
    const getUser = (data) =>
    {
        getUserDetails(props.user_id, null,(response) =>
        {
            let userData = getDataFromResponse(response)[0] ;
            const emailNotification = +userData.email_notifications === 0 ? false :true;

            setValue ( 'user',
                {
                    organisation_id: {value: userData.organisation_id},
                    user_id: { value: userData.idusers},
                    firstname: userData.firstname,
                    surname: userData.surname,
                    description: userData.description,
                    username: userData.username,
                    userTypeId: { value: +(userData.userTypeId) },
                    us_description: userData.us_description,
                    team_id: { value: +(userData.team_id) },
                    email: userData.email,
                    telno: userData.telno,
                    address1: userData.address1,
                    address2: userData.address2,
                    address3: userData.address3,
                    postcode: userData.postcode,
                    unique_user_reference: userData.unique_user_reference,
                    email_notifications: emailNotification
                }) ;

            setData({ isLoading: false, data: userData });
            setImageDataAlias(userData.document_id);
        });
    }

    const onClickCancel = () =>
    {
        props.onSaveCompleted ('cancel');
        props.onClose() ;
    }

    const doCreateUser = ( formData ) =>
    {
        saveNewUser(formData, (response) =>
        {
            const uurInUse = getNamedCustomDataFromResponse( response, 'already_exists') ;
            const emailError = getNamedCustomDataFromResponse( response, 'email_error') ;

            if ( uurInUse == true )
            {
                bootbox.alert({
                    size: "small",
                    message: 'You entered a unique reference number ' + formData['unique_user_reference'] + ' that is already assigned to another arcbox user in your organisation.\n\nPlease update and re-submit.',
                    callback: (result =>
                    {
                       //
                    })
                })
            }
            else if ( emailError == true )
            {
                const errorMessage = response.custom_data['error_message'];

                bootbox.alert({
                    size: "small",
                    message: errorMessage,
                    callback: (result =>
                    {
                        props.onSaveCompleted('saved');
                        props.onClose();
                    })
                })
            }
            else
            {
                bootbox.alert({
                    size: "small",
                    message: 'New User Created - an email has been sent to the user to register for ARCBOX',
                    callback: (result =>
                    {
                        props.onSaveCompleted('saved');
                        props.onClose();
                    })
                })
            }

        });
    }

    const doUpdateUser = ( formData ) =>
    {
        updateUserDetails(props.user_id, formData, (response) =>
        {
            const custom = getNamedCustomDataFromResponse( response, 'already_exists') ;

            if ( custom == true )
            {
                bootbox.alert({
                    size: "small",
                    message: 'You entered a unique reference number ' + formData.user['unique_user_reference'] + ' that is already assigned to another arcbox user in your organisation.\n\nPlease update and re-submit.',
                    callback: (result =>
                    {
                        //
                    })
                })
            }
            else
            {
                bootbox.alert({
                    size: "small",
                    message: 'User has been Updated',
                    callback: (result =>
                    {
                        props.onSaveCompleted('saved');
                        props.onClose();
                    })
                })
            }
        });
    }

    const doDelete = ( callback ) =>
    {
        deleteUser (props.user_id, (response) =>
        {
            props.onSaveCompleted ('saved');
            props.onClose() ;
        });
    }

    const Title = ( props ) =>
    {
        return <h3>{titles[props.mode]}</h3>
    }

    const isViewOnly = props.mode === 'view';

    const getSubmitButtonText = ( mode ) =>
    {
        return submitButtonText() ;
    }

    const getSubmitButtonStyle= ( mode ) =>
    {
        switch ( mode )
        {
            case 'delete':
                return "btn btn-icon btn-danger btn-icon-right btn-small" ;
            default:
                return "btn btn-icon btn-primary btn-icon-right btn-small" ;
        }
    }

    const submitButton = (mode, onClick) =>
    {
        const clickHandler = buttonState === '' ? onClick : null;

        return (
            <button onClick={clickHandler} type='button' style={{marginRight: '10px', marginLeft: '10px'}} disabled={buttonState} className={getSubmitButtonStyle(mode)}>{getSubmitButtonText(mode)}<i className="et-save" /></button>
        )
    }

    const onSubmit = (data, status) => {
        switch (props.mode)
        {
            case 'create' :
                data.user['image'] = newImageData;
                doCreateUser(data.user);
                break
            case 'edit':
                if (newImageData !== null) data.user['image'] = newImageData;
                doUpdateUser(data);
                break;

            case 'delete' :
                bootbox.confirm({
                    size: "small",
                    message: "Are you sure you want to archive this User?",
                    callback: (result =>
                    {
                        if (result)
                        {
                            doDelete();
                        }
                    })
                })
                break;
        }
    }

    const onClickSaveButton = (status) => {
        handleSubmit(onSubmit)(status);
    }

    const onImageChange = ( imageUrl ) =>
    {
        const reader = new window.FileReader();
        reader.readAsDataURL(imageUrl);

        reader.onloadend = () =>
        {
            setNewImageData ( reader.result ) ;
            setImageDataAlias ( reader.result ) ;
        }
    }

    const selectedUserType = watch('user.userTypeId');
    const selectedOrg = watch('user.organisation_id');

    const isReadOnly = props.mode === 'view' || props.mode === 'delete' ;

    const handleRemoveImage = () => {
        setNewImageData("");
        setImageDataAlias(null);
    }

    const validateDropdown = (val) =>
    {
        if ( val === null )
        {
            return "You must select a user type." ;
        }
    }

    const validateDropdownOrganisations = (val) =>
    {
        if (+val === 0)
        {
            return "You must select an organisation";
        }
    }

    const renderHookForm = ( prop )  =>
    {
        const readOnlyMode = props.mode === 'view' || props.mode === 'delete' ? 'readonly' : '' ;
        const selectedUserTypeValue = selectedUserType === undefined || selectedUserType === null ? 0 : selectedUserType.value ;
        const selectedOrgValue = selectedOrg !== undefined ? selectedOrg.value : 'current';
        const image_id = props.mode === 'create' ? null : data.data.document_id;
        const userTypeReadOnly = props.mode === 'create' && props.user_type_id !== UserTypes.OTHER  ? false : true;
        const prefNameReadOnly = props.lock_pref_name && readOnlyMode === '' ? 'readonly': readOnlyMode;
        const isSysAdmin = userType === UserTypes.ADMIN;

        return (
            <Fragment>
                <form className='registration-form' onSubmit={handleSubmit(onSubmit)}>

                    <div className="profile-img-container-wrap profile-img-container-wrap_child">
                        {!isReadOnly &&  
                        <div className="post-all-image-wrap">
                            <div
                                className={imageDataAlias === null ?
                                            "post-all-image"
                                            :
                                            "post-all-image post-all-image_show"
                                        }
                            >
                                <DemoModal 
                                image_id={image_id} 
                                provider_id={1} 
                                dimensions={150} 
                                onImageChange={onImageChange}
                                newImageData={newImageData}
                                imageDataAlias={imageDataAlias}
                                data={data}
                                />
                                <span onClick={handleRemoveImage} className="post-image-remove">
                                    <i className='icon-close'/>
                                </span>
                                <div className="post-all-image-overlay post-all-image-overlay_single"></div>
                            </div>
                        </div>
                        }
                        {isReadOnly && <img src={getChildImageUrl(data.data.document_id, data.data.user_id)} style={{width: '150px'}} />}
                    </div>

                    { isSysAdmin && <div className='row'>
                        <div className='col-md-12'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Organisations</label>
                                <DropdownOrganisations readOnly={false} control={control}
                                                       name='user.organisation_id'
                                                       rules={{required: true, validate: validateDropdownOrganisations}}
                                                       placeholder='Please select an organisation'
                                                       isSearchable={true}
                                                       isClearable={true}
                                                       isMulti={false}/>
                                {formErrors.domain?.user.organisation_id && <ErrorDiv>Please select an organisation</ErrorDiv>}
                            </div>
                        </div>
                    </div> }

                    <div className='row'>
                        <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Firstname</label>
                                <input readOnly={readOnlyMode} className='form-control' name='user.firstname' id='firstname' {...register("user.firstname", { required: true})} />
                                { formErrors.user?.firstname && <ErrorDiv>Please enter a firstname</ErrorDiv> }
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Surname</label>
                                <input readOnly={readOnlyMode}className='form-control' name='user.surname' id='surname' {...register("user.surname", { required: true})}  />
                                { formErrors.user?.surname && <ErrorDiv>Please enter a surname</ErrorDiv> }
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Preferred Name</label>
                                <input readOnly={prefNameReadOnly} className='form-control' name='user.description' id='description' {...register("user.description")} />
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Unique Reference Number</label>
                                <input readOnly={readOnlyMode} className='form-control' name='user.unique_user_reference' id='unique_user_reference' {...register("user.unique_user_reference")} />
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>User Type</label>
                                <DropdownUserTypes readOnly={userTypeReadOnly}
                                                   control={control}
                                                   mode={props.mode}
                                                   name='user.userTypeId'
                                                   rules={{required: true, validate: validateDropdown}}
                                                   placeholder='Please select a user type'
                                                   isSearchable={true}
                                                   isClearable={true}/>
                                {formErrors.user?.userTypeId && <ErrorDiv>{formErrors.user.userTypeId.message}</ErrorDiv>}
                            </div>
                        </div>

                        <div className='col-md-6'>
                            { UserRoleGroups.CAN_BE_EDITOR.includes(selectedUserTypeValue) && <div>
                                <label>Email Notifications</label>
                                <div style={{marginTop: '5px'}}>
                                    <FormToggle readOnly={false} control={control} name='user.email_notifications'/>
                                    {formErrors.user?.email_notifications &&
                                        <ErrorDiv>{formErrors.user.has_contact_plan.message}</ErrorDiv>}
                                </div>
                            </div>}
                        </div>

                    </div>

                    <div className='row'>

                        { props.mode !== 'create' && <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Username</label>
                                <input readOnly='readonly' className='form-control' name='user.username' id='username' {...register("user.username")} />
                            </div>
                        </div>}

                        { props.mode !== 'create' && <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>ARCBOX Status</label>
                                <input readOnly='readonly' className='form-control' name='user.us_description' id='us_description' {...register("user.us_description")} />
                            </div>
                        </div>}
                    </div>

                    { (UserRoleGroups.CAN_BE_STAFF.includes(selectedUserTypeValue) && props.mode === 'create') && <div className='row'>
                        <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Team</label>
                                <DropdownOrgTeams readOnly={false} control={control}
                                                   mode={props.mode}
                                                   name='user.team_id'
                                                   rules={{required: false}}
                                                   placeholder='Please select a user team'
                                                   isSearchable={true}
                                                   isClearable={true}
                                                  organisation={selectedOrgValue}/>
                                {formErrors.user?.team_id &&
                                    <ErrorDiv>{formErrors.user.team_id.message}</ErrorDiv>}
                            </div>
                        </div>
                    </div>}

                    <div className='row'>
                        <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Email</label>
                                <input readOnly={readOnlyMode} className='form-control' name='user.email' id='email' type='email' {...register("user.email",
                                    {
                                        required: {value: true},
                                        pattern: {
                                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                            message: "Please enter a valid email !"
                                        }
                                    }
                                )} />
                                { formErrors.user?.email && <ErrorDiv>Please enter a valid email</ErrorDiv> }
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Telephone</label>
                                <input readOnly={readOnlyMode} className='form-control' name='user.telno' id='telno' {...register("user.telno")} />
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Address Line 1</label>
                                <input readOnly={readOnlyMode} className='form-control' name='user.address1' id='address1' {...register("user.address1")} />
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Address Line 2</label>
                                <input readOnly={readOnlyMode} className='form-control' name='user.address2' id='address2' {...register("user.address2")} />
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Address Line 3</label>
                                <input readOnly={readOnlyMode} className='form-control' name='user.address3' id='address3' {...register("user.address3")} />
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Post Code</label>
                                <input readOnly={readOnlyMode} className='form-control' name='user.postcode' id='postcode' {...register("user.postcode")} />
                            </div>
                        </div>
                    </div>

                    <div className="d-flex flex-row justify-content-end" style={{marginTop: '15px'}}>
                        <button onClick={onClickCancel} className="btn btn-secondary">Cancel<i className="et-arrow-bold-left" /></button>
                        {!isViewOnly && submitButton(props.mode, onClickSaveButton)}
                    </div>
                </form>
            </Fragment>
        )
    }

    return (
        <ModalContentWrapper className="modal-wrapper">
            <Title mode={props.mode} />
            <div style={{width: props.width}}>
                { data.isLoading && <SpinnerDiv /> }
                { !data.isLoading && renderHookForm ()}
            </div>
        </ModalContentWrapper>
    )
}

export default ModalAddUser;

ModalAddUser.defaultProps =
{
    width: '600px'
}

ModalAddUser.propTypes = {
    user_id: PropTypes.string,
    width: PropTypes.string,
    mode: PropTypes.string.isRequired,
    onSaveCompleted: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};
